"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specifiedAccidentsDogBase = exports.specifiedAccidentsDefaultDogList = exports.specifiedAccidentsDefaultCatList = exports.specifiedAccidentsCatBase = exports["default"] = void 0;
var specifiedAccidentsDogBase = exports.specifiedAccidentsDogBase = {
  "default": {
    header: {
      title: 'Specified Accidental Injury',
      subtitle: 'means physical harm or injury arising from an Accident that is a consequence of or results in one of the following:'
    },
    footer: 'Note: Conditions covered by the specified accidental injury cover section of the policy are specified in the PDS.'
  }
};
var specifiedAccidentsDefaultDogList = exports.specifiedAccidentsDefaultDogList = {
  separators: {
    base: ';',
    secondLast: '; or',
    last: '.'
  },
  style: 'unordered',
  type: 'disc',
  listItems: {
    'motor': 'a motor vehicle incident',
    'burn': 'a burn or electrocution',
    'allergy': {
      label: 'an allergic reaction to the following insect and arachnid bites:',
      items: {
        type: 'i',
        style: 'ordered',
        separators: {
          "default": ';',
          secondLast: ', and',
          last: '.'
        },
        listItems: ['ants', 'bees', 'flies', 'mosquitoes', 'scorpions', 'spiders', 'wasps']
      }
    },
    'bone': 'a bone or traumatic tooth fracture',
    'snake': 'a snake bite toxicity',
    'ligament': 'a traumatic ligament or tendon injury',
    'bite': 'a bite wound or fight wound abscesses',
    'laceration': 'lacerations or abrasion of tissue, skin or mucous membrane due to external violence'
  }
};
var specifiedAccidentsCatBase = exports.specifiedAccidentsCatBase = {
  "default": {
    header: {
      title: 'Specified Accidental Injury',
      subtitle: 'means physical harm or injury arising from an Accident that is the consequence of one of the following:'
    },
    footer: 'Note: Conditions covered by the specified accidental injury cover section of the policy are specified in the PDS.'
  }
};
var specifiedAccidentsDefaultCatList = exports.specifiedAccidentsDefaultCatList = {
  separators: {
    base: ';',
    secondLast: '; or',
    last: '.'
  },
  style: 'unordered',
  type: 'disc',
  listItems: {
    'foreignObject': 'ingestion of a foreign object',
    'poisoning': 'poisoning'
  }
};
var _default = exports["default"] = {
  specifiedAccidentsCatBase: specifiedAccidentsCatBase,
  specifiedAccidentsDefaultCatList: specifiedAccidentsDefaultCatList,
  specifiedAccidentsDogBase: specifiedAccidentsDogBase,
  specifiedAccidentsDefaultDogList: specifiedAccidentsDefaultDogList
};